<!-- ota升级 -->
<div *ngIf="iconVisible"
    class="alarm-number"
    [nTooltip]="alarmDropdown"
    nTooltipTrigger="click"
    nTooltipTheme="black"
    [nTooltipBeforeHide]="beforePanelHide"
    nTooltipOverlayClass="upgrade-overlay"
    [(nTooltipVisible)]="visible">
    <div>
        <svg class="icon">
            <use [attr.xlink:href]="getStatusIconSvg | fn :currentProcess"></use>
        </svg>
    </div>
</div>

<!-- 升级中面板 -->
<ng-template #alarmDropdown>
    <div class="upgrade-panel">
        <div class="upgrade-panel-title">
            <div class="upgrade-panel-title-name">
                {{i18n.otaUpgrade}}
            </div>
            <div class="upgrade-panel-title-count" *ngIf="ifShowCount | fn :currentProcess">
                <ul>
                    <li *ngIf="str.ifShowTotal | fn :currentProcess">
                        <div class="upgrade-panel-title-count-all">{{count.all}}</div>
                        <div>{{i18n.total}}</div>
                    </li>
                    <li>
                        <div class="upgrade-panel-title-count-suc">{{count.suc}}</div>
                        <div>{{i18n.sucCount}}</div>
                    </li>
                    <li>
                        <div class="upgrade-panel-title-count-fail">{{count.fail}}</div>
                        <div>{{i18n.failedCount}}</div>
                    </li>
                    <li>
                        <div class="upgrade-panel-title-count-ignore">{{count.ignore}}</div>
                        <div>{{i18n.ignoreCount}}</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="upgrade-panel-line"></div>
        <ng-container>
            <ng-container *ngIf="currentProcess === Progress.verifyFailed; else upgradingTip">
                <n-tip
                    class="pt-10"
                    style="display: flex"
                    type="warning"
                    [content]="i18n.xistRiskInfo">
                </n-tip>
            </ng-container>
            <!-- 多条提示信息 -->
            <ng-template #upgradingTip>
                <n-lv>
                    <n-lv-item [label]="i18n.circleDot">{{i18n.upgradeMsg1}}<span class="upgrade-panel-tip-warn">{{i18n.upgradeMsg2}}</span></n-lv-item>
                    <n-lv-item [label]="i18n.circleDot">{{i18n.upgradeMsg3}}</n-lv-item>
                    <n-lv-item [label]="i18n.circleDot">{{i18n.upgradeMsg4}}</n-lv-item>
                </n-lv>
            </ng-template>
            <div class="upgrade-panel-progress">
                <div class="upgrade-panel-progress-title">{{i18n.progress}}</div>
                <div style="display:inline-block;width:85%;">
                    <p-progressBar [value]="upgradeStatus.checkProgress"
                        [color]="sysUpProgressDesc[currentProcess]?.color"
                        [showValue]="false"
                        width="90%"
                        [class.no-motion]="!progressMotion">
                    </p-progressBar>
                </div>
                <div style="display:inline-block;margin-left: .07rem;">{{upgradeStatus.checkProgress}}%</div>
                <div class="upgrade-panel-progress-desc"
                    [ngStyle]="{'color': sysUpProgressDesc[currentProcess]?.color}">
                    <svg class="icon"
                        [ngClass]="{'uploading': sysUpProgressDesc[currentProcess]?.uploading}">
                        <use [attr.xlink:href]="'#icon-' + sysUpProgressDesc[currentProcess]?.icon"/>
                    </svg>
                    {{sysUpProgressDesc[currentProcess]?.text}}
                </div>
            </div>
            <!-- 分发失败详情 -->
            <div class="upgrade-panel-detail" *ngIf="ifShowFailDetail | fn :currentProcess :distributeFailDetails.length">
                <div class="error-color">
                    <ng-container *ngFor="let item of distributeFailDetails">
                        <div *ngIf="item.CMO_DETAIL_ATOM_STATE === CmoDetailAtomState.fail || item.CMO_DETAIL_ATOM_STATE === CmoDetailAtomState.pause">
                            {{getErrorInfo | fn :item}}
                        </div>
                    </ng-container>
                </div>
            </div>
            <!-- 升级前检查、升级后检查 -->
            <div class="upgrade-panel-detail" *ngIf="isCheck">
                <div *ngFor="let checkDetail of checkDetails;let i = index" class="upgrade-panel-detail-item">
                    <!-- 检查项 -->
                    <div class="upgrade-panel-detail-title">
                        <span class="upgrade-panel-detail-icon">
                            <svg class="icon" [ngClass]="{'uploading': +checkDetail.checkResult === CheckResult.Checking}">
                                <use [attr.xlink:href]="str.getSvg | fn :+checkDetail.checkResult"/>
                            </svg>
                        </span>
                        {{str.getCheckItemValue | fn :checkDetail.checkItem}}
                    </div>
                    <!-- 忽略 -->
                    <div class="upgrade-panel-detail-content">
                        <span class="upgrade-panel-detail-content-time">{{checkDetail.checkTime || UNPLACEHOLDER}}</span>
                        <span *ngIf="str.ifShowSkip | fn :checkDetail.isSupportSkip :checkDetail.checkResult :currentProcess"
                            class="upgrade-panel-detail-content-btn"
                            (click)="onSkipCheckDetails(i)">
                            {{i18n.skip}}
                        </span>
                        <span *ngIf="+checkDetail.checkResult === CheckResult.Ignore"
                            class="upgrade-panel-detail-icon-btn ignorestyle">
                            {{i18n.skipped}}
                        </span>
                    </div>
                    <!-- 查看详情 -->
                    <div *ngIf="checkDetail.nodeInfoArr"
                        class="upgrade-panel-detail-icon">
                        <div (click)="onShowCheckDetails(checkDetail?.checkItem)">
                            <!-- 失败的 -->
                            <ng-container *ngIf="str.isCheckResultFailed | fn :+checkDetail.checkResult; else common">
                                <span class="error-red">{{i18n.failDetail}}</span>
                            </ng-container>
                            <!-- 成功的 -->
                            <ng-template #common>
                                <span class="common-blue">{{i18n.detail}}</span>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 升级中 -->
            <div class="upgrade-panel-detail" *ngIf="!isCheck">
                <div *ngFor="let checkDetail of checkDetails;let i = index" class="upgrade-panel-detail-item">
                    <div class="upgrade-panel-detail-content">
                        <span class="upgrade-panel-detail-content-time">{{checkDetail.checkItem}}</span>
                        <span class="upgrade-panel-detail-content-status" *ngIf="+checkDetail.checkResult === 0" style="color:#A0A4B1">
                            {{i18n.notInstall}}
                        </span>
                        <span class="upgrade-panel-detail-content-status" *ngIf="+checkDetail.checkResult === 1" style="color:#3DCCA6">
                            <svg class="icon uploading"><use xlink:href="#icon-loading"/></svg>
                            {{i18n.inStalling}}
                        </span>
                        <span class="upgrade-panel-detail-content-status" *ngIf="+checkDetail.checkResult === 2" style="color:#3DCCA6">
                            {{i18n.checkSuccessed}}
                        </span>
                        <span class="upgrade-panel-detail-content-status" *ngIf="+checkDetail.checkResult === 3" style="color:#FF4C4C">
                            {{i18n.checkFailed}}
                        </span>
                        <div class="view-details" (click)="onShowUpgradeDetails(i)" *ngIf="+checkDetail.checkResult ===3">
                            <svg class="icon" *ngIf="!checkDetail.showDetail"><use xlink:href="#icon-arrow-lg-right"/></svg>
                            <svg class="icon" *ngIf="checkDetail.showDetail"><use xlink:href="#icon-arrow-lg-top"/></svg>
                        </div>
                        <div style="content: '';clear:both;"></div>
                        <div style="width: 100%;background: #4a516c;padding: .1rem .16rem;color: #FF4C4C;margin: .1rem 0;" *ngIf="checkDetail.showDetail && +checkDetail.checkResult ===3">
                            {{checkDetail.nodeInfo}}
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="upgrade-panel-operat" class="active">
            <!-- 重试 -->
            <span *ngIf="showRetry | fn :currentProcess"
                class="mr-2"
                (click)="onRetry()">
                <svg class="icon upgrade-panel-operat-icon">
                    <use xlink:href="#app-icon-retry"></use>
                </svg>
                <span class="upgrade-panel-operat-btn">{{i18n.reTry}}</span>
            </span>
            <!-- 回滚 -->
            <span (click)="onUpgrade(UpgradeTypeE.Rollback)"
                *ngIf="currentProcess === Progress.upgradePause || currentProcess === Progress.rollBackFailed"
                class="mr-2">
                <svg class="icon upgrade-panel-operat-icon">
                    <use xlink:href="#app-icon-rollback"></use>
                </svg>
                <span class="upgrade-panel-operat-btn">{{i18n.rollback}}</span>
            </span>
            <!-- 删除 -->
            <span *ngIf="ifShowExit | fn :currentProcess"
                class="mr-2"
                (click)="onExit()">
                <svg class="icon upgrade-panel-operat-icon">
                    <use xlink:href="#icon-close"></use>
                </svg>
                <span class="upgrade-panel-operat-btn">{{i18n.exit}}</span>
            </span>
        </div>
        <div class="upgrade-panel-successd" style="text-align:center;" *ngIf="showResultPage | fn :currentProcess">
            <button pButton
                style="margin: .2rem .2rem .1rem .2rem;"
                class="ui-finish-button"
                type="button"
                (click)="onClose()"
                [label]="i18n.finishBtn">
            </button>
        </div>
    </div>
</ng-template>
